// Compatibility for menus cached before these pages moved into settings or records.
export const isSettingsOnlyAddon = addonId => addonId === 'publicForms';

export const isSettingsOnlyAddonMenuItem = item => isSettingsOnlyAddon(item?.addonId)
  || String(item?.id || '').startsWith('addon:publicForms:')
  || /^\/(?:bos\/)?addon\/publicForms(?:\/|$)/.test(item?.url || '');

export default function normalizeAddonMenu(menu) {
  if (!Array.isArray(menu)) return menu;
  return menu.filter(item => !isSettingsOnlyAddonMenuItem(item) && !isRetiredEconomicsMenuItem(item) && !(item?.isAddonPage && item.addonId === 'cleanup' && (
    item.componentKey === 'cleanupReview' || item.url === '/addon/cleanup/review' || item.id === 'addon:cleanup:review'
  )));
}

export function isRetiredEconomicsMenuItem(item) {
  if (!item?.isAddonPage) return false;
  return (item.addonId === 'estimation' && (item.componentKey === 'estimationWorkspace' || item.url === '/addon/estimation/workspace' || item.id === 'addon:estimation:estimationWorkspace'))
    || (item.addonId === 'budgetManagement' && (item.componentKey === 'projectCostWorkspace' || item.url === '/addon/budgetManagement/project-costs' || item.id === 'addon:budgetManagement:projectCostWorkspace'));
}
